module.exports = __webpack_public_path__ + "img/img_di@2x.30b9392a.png";